/* eslint-disable */
/** @jsxRuntime classic */
/** @jsx jsx */
import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { jsx } from "@emotion/react";

const widget = {
  overflow: "hidden",
  minHeight: "475px",
};

const cardList = {
  display: "flex",
  flexDirection: "column",
  padding: "24px",
  "@media (max-width: 767px)": {
    padding: "16px",
  },
  "& > div": {
    marginBottom: "16px",
    "&:last-child": {
      marginBottom: "0px",
    },
  },
};

const progressBar = {
  "& h5": {
    paddingBottom: "8px",
  },
  "& h2": {
    color: "var(--Z4)",
  },
  "& span": {
    color: "var(--Z4)",
    fontSize: "12px",
    whiteSpace: "nowrap",
    paddingLeft: "16px",
    "@media (max-width: 767px)": {
      paddingLeft: "8px",
    },
  },
};

const titleCard = {
  backgroundColor: "var(--A1)",
  color: "var(--A2)",
  width: "100%",
  padding: "16px 24px 29px 24px",
  "& .head-m": {
    color: "var(--A2)",
    marginBottom: "24px",
  },
  "& .label-large": {
    color: "var(--B3)",
    marginBottom: "10px",
  },
};

const titleLabel = {
  color: "var(--A5) !important",
};

const titleMainHeading = {
  marginBottom: "16px !important",
  "@media (max-width: 767px)": {
    marginBottom: "8px !important",
  },
};

const lockedArrow = {
  width: "16px",
  position: "absolute",
  top: " -14px",
  left: "40px",
  "@media (max-width: 767px)": {
    left: "24px",
  },
};

const BorderLinearProgress = withStyles({
  root: {
    borderRadius: "10px",
    width: "100%",
    height: "16px",
    marginTop: "7px",
  },
  colorPrimary: {
    /* Z18 */
    background: "#D3D3D3",
  },
  bar: {
    borderRadius: "10px",
    backgroundColor: "var(--B1)",
  },
})(LinearProgress);

export const CompletionRules = {
  all: "All",
  setAmount: "Set Amount",
  requiredOnly: "Required Only",
};

const fractionToPercent = (numerator, denominator) =>
  (numerator / denominator) * 100;

export const CheckListWidget = ({ children, className = "", widgetRef }) => (
  <div className={`col-md-8 col-xs-12  ${className}`} ref={widgetRef}>
    <Paper css={widget}>{children}</Paper>
  </div>
);

function displayProgressSubHeading(completionRule, actionItems, completeAny) {
  switch (completionRule) {
    case CompletionRules.all:
      return "Complete all action items to complete this checklist.";
    case CompletionRules.requiredOnly:
      return "Complete all required action items to complete this checklist.";
    case CompletionRules.setAmount:
      return `Complete at least ${completeAny}/${actionItems.length} action items to complete this checklist`;
    default:
      return "";
  }
}

function getTotalToComplete(completionRule, actionItems, completeAny) {
  switch (completionRule) {
    case CompletionRules.all:
      return actionItems.length;
    case CompletionRules.requiredOnly:
      return actionItems.filter((item) => item.Requirement === "Required")
        .length;
    case CompletionRules.setAmount:
      return completeAny;
    default:
      return "";
  }
}

export const countCompletedSteps = (actionItems) =>
  actionItems.filter((actionItem) => actionItem.IsComplete).length || 0;

export const ProgressBar = ({
  heading,
  actionItems,
  completionRule,
  completeAny,
}) => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const completedSteps = countCompletedSteps(actionItems);
  const toComplete = getTotalToComplete(
    completionRule,
    actionItems,
    completeAny
  );
  const completed = completedSteps >= toComplete ? toComplete : completedSteps;
  return (
    <div css={progressBar}>
      <h5 className="head-xs">{heading}</h5>
      <h2 className="subhead-s">
        {displayProgressSubHeading(completionRule, actionItems, completeAny)}
      </h2>
      <div className="displayflex aligncenter">
        <BorderLinearProgress
          variant="determinate"
          value={fractionToPercent(completed, toComplete)}
        />
        <span>
          {completed}/{toComplete} {isMobile ? "" : "actions"} completed
        </span>
      </div>
    </div>
  );
};
export const TitleCard = ({label, heading, subHeading }) => (
  <div css={titleCard}>
    <div css={titleLabel} className="label-large">
      {label}
    </div>
    <div css={titleMainHeading} className="head-m">
      {heading}
    </div>
    {subHeading && <div dangerouslySetInnerHTML={{ __html: subHeading }} />}
  </div>
);

export const LockedArrow = () => (
  <div className="relative width100">
    <svg
      css={lockedArrow}
      width="16"
      height="29"
      viewBox="0 0 16 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.29289 28.7071C7.68342 29.0976 8.31658 29.0976 8.70711 28.7071L15.0711 22.3431C15.4616 21.9526 15.4616 21.3195 15.0711 20.9289C14.6805 20.5384 14.0474 20.5384 13.6569 20.9289L8 26.5858L2.34315 20.9289C1.95262 20.5384 1.31946 20.5384 0.928933 20.9289C0.538409 21.3195 0.538409 21.9526 0.928933 22.3431L7.29289 28.7071ZM7 4.37114e-08L7 28L9 28L9 -4.37114e-08L7 4.37114e-08Z"
        fill="#D3D3D3"
      />
    </svg>
  </div>
);

export const CardList = ({ children }) => <div css={cardList}>{children}</div>;
